import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#A7E7C4',
} as const

export const resources = {
  loginBg: '/images/florastory/login/login-bg.webp',
  logo: '',
  novel: '',
  facebookIcon: '/images/florastory/login/icon-facebook-logo.png',
  googleIcon: '/images/florastory/login/icon-google-logo.png',
  appleIcon: '/images/florastory/login/icon-apple-logo.png',
  emailIcon: '/images/florastory/login/icon-email.png',
  emailCodeIcon: '/images/florastory/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
